import { Component } from '@angular/core';

@Component({
  selector: 'app-feature-info',
  imports: [],
  templateUrl: './feature-info.component.html',
  styleUrl: './feature-info.component.css',
})
export class FeatureInfoComponent {}
